import React, { useState, useEffect, useRef } from 'react'
// import { Link } from 'gatsby'
import cn from 'classnames'

import Q1 from '~/assets/svg/q1.svg'
import Q2 from '~/assets/svg/q2.svg'
import Q3 from '~/assets/svg/q3.svg'
import Q4 from '~/assets/svg/q4.svg'
import Q5 from '~/assets/svg/q5.svg'

import s from './styles.module.scss'

const preset = {
  q: 'question_v',
  b1: 'break1',
  b2: 'break2',
  b3: 'break3',
  b4: 'break4',
  b5: 'break5',
  bkv: 'break_kv',
}

type Props = {
  shape: 'q' | 'b1' | 'b2' | 'b3' | 'b4' | 'b5' | 'bkv'
  delay: number
}

const Component: React.FC<Props> = ({ shape, delay }) => {
  return (
    <div
      className={cn(s.q, s.kv, s.color_white, {
        [s[`shape_${preset[shape]}`]]: true,
        [s[`delay_${delay}`]]: true,
      })}
    >
      <Q1 />
      <Q2 />
      <Q3 />
      <Q4 />
      <Q5 />
    </div>
  )
}

export default Component
